import React from "react";
import Txt from "../../typography/Txt";

const DetailRowLabel = ({ children, fontSize = 11.5, sx }) => {
  return (
    <Txt sx={{ fontSize: fontSize, color: "#94a3b8", ...sx }}>{children}</Txt>
  );
};

export default DetailRowLabel;
